import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import AllNcr from "./components/AllNcr";

import AccessDenied from "components/AccessDenied";
import PageContainer from "components/PageContainer";
import { useAuth } from "contexts/auth.context";
import Footer from "examples/Footer";
import { Route, Routes } from "react-router-dom";

function Ncr() {
  const { checkPermission } = useAuth();

  if (
    Object.keys(checkPermission("ncr")).filter(
      (key) => checkPermission("ncr")[key],
    ).length === 0
  ) {
    return <AccessDenied type="page" />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <PageContainer>
        <Routes>
          <Route index element={<AllNcr permissions={checkPermission("ncr")} />} />
        </Routes>
      </PageContainer>

      <Footer />
    </DashboardLayout>
  );
}

export default Ncr;
